import Vue from 'vue';

import customizerStore from './vuex/customizer/store';
import ecommerceStore from './vuex/ecommerce/store';

let lastLogoTap = null;
let logoTaps = 0;

let lastLogMessage = null;

export default {
    state() {
        return {
            uptime: new Date(),

            // Global event bus.
            eventBus: new Vue(),

            // Initialization options.
            options: null,

            // Are we in the self-destruct mode.
            selfDestruct: false,

            // Global busy indicator.
            globalBusy: false,

            // Background app state.
            backgroundState: null,

            // Current loading state.
            loadState: null,

            // Is the app connected to the internet
            isOnline: true,

            // Selected step.
            selectedStep: 'splash',

            // Selected step parameters.
            selectedStepParameters: null,

            // Window width.
            windowWidth: window.innerWidth,

            // Window height.
            windowHeight: window.innerHeight,

            // Renderer height.
            rendererHeight: null,

            // Timeout popup.
            timeoutShown: false,

            // Kiosk restart popup.
            kioskRestartShown: false,

            // Reset popup
            resetShown: false,

            // Service menu.
            serviceMenuShown: false,

            // Printing error.
            printingErrorShown: null,

            // Save error.
            saveErrorShown: null,

            // Last printing error.
            lastKnownError: null,

            // Last printing status.
            lastKnownStatus: null,

            // Print progress menu.
            printingShown: false,

            // Change warning.
            changeWarningShown: null,

            // Out of stock warning.
            outOfStockWarningShown: null,

            // Used to display copy for temporarily out of stock.
            isTemporarilyOutOfStock: false,

            // Counts UI interactions.
            uiInteractions: 0,

            // If renderer is shown, show this view.
            preferredView: 'Main',

            // If renderer is hidden, show it with the desired view.
            forcedView: null,

            // Selected view for the main experience (except the review step)
            selectedToggleView: 'Main',

            // Warning modal shown when the Funko logo is clicked.
            exitModalShown: false,

            // Warning modal shown when the mouse leaves the viewport.
            mouseLeaveModalShown: false,

            // Used to track whether the mouse leave modal has already been shown.
            mouseLeaveModalWasShown: false,

            // Show protector popup.
            protectorUpsellShown: false,

            // Show discreet packaging popup/"tooltip".
            discreetPackagingModalShown: false,

            // Show special box modal (accessories step).
            specialBoxModalShown: false,

            // Used to prevent the special box modal from showing more than once.
            specialBoxModalWasShown: false,

            // Show inspect modal.
            inspectModalShown: false,

            // Component to show in inspect modal.
            inspectModalComponent: null,

            // Show attach pack modal.
            attachPackModalShown: false,

            // Attach pack to show in attach pack modal.
            attachPackModalComponent: null,

            // Attach pack to add from attach pack inspect modal.
            attachPackAddComponent: null,

            // Show attach pack info modal.
            attachPackInfoModalShown: false,

            // Used to track whether the attach pack info modal has already been shown.
            attachPackInfoModalWasShown: false,

            // Used to show additional info about a recommended product.
            productInfoModalShown: false,

            // Show pet pack info modal.
            petPackInfoModalShown: false,

            // Recommended product to show in the product info modal.
            productInfoModalComponent: null,

            // Show switch pop modal.
            switchPopModalShown: false,

            // Tracks whether the AI modal was triggered by the switch pop modal.
            launchedFromSwitchModal: false,

            // Show AI modal.
            aiModalShown: false,

            // Used to show preview modal after building from the AI modal.
            builtFromSelfie: false,

            // Show AI Preview modal.
            aiPreviewModalShown: false,

            // Show Name Pop modal.
            namePopModalShown: false,

            // Used to prevent the name pop modal from showing more than once on the body step.
            namePopModalWasShown: false,

            // Used to prevent the name pop modal from showing more than once on the body step for pop 2.
            namePop2ModalWasShown: false,

            // Show Skin Tone modal.
            skinToneModalShown: false,

            // Enable spelling bee option.
            isSpellingBeeOptionAvailable: false,

            // Should show spelling bee UI/UX. User opted in.
            isSpellingBee: false,

            // Selected type.
            spellingBeeType: null,

            // Show spelling bee selector modal.
            showSbSelectorModal: true,

            // Show holiday calendar modal.
            showCalendarModal: false,

            // Determines whether a scrollbar is being shown (kiosk experience only).
            hasScrollbar: false,

            // Main states used in AI modal
            aiStates: {
                default: 'default',
                selfie: 'selfie',
                upload: 'upload',
            },
            aiActiveState: 'default',
            // Selfie states used in AI modal
            aiSelfieStates: {
                default: 'default',
                sayCheese: 'sayCheese',
                loading: 'loading',
                building: 'building',
                error: 'error',
            },
            aiSelfieActiveState: 'default',
            // Photo Upload states used in AI modal
            aiUploadStates: {
                loading: 'loading',
                building: 'building',
                review: 'review',
                error: 'error',
            },
            aiUploadActiveState: 'loading',

            // Pack type selected on TwoPackSelector screen
            packType: null,

            // Used to show the loading spinner when customization is launched from the AI modal
            aiSpinnerShown: false,

            // Should we load the controller but defer the AI modal.
            deferAiTrigger: false,
            // Is the AI modal shown for the first time.
            aiFirstTime: true,

            screensaverShown: false,

            // Holiday calendar.
            autoAddHolidayCalendar: null,
        };
    },

    getters: {
        outOfPaper(state) {
            if (state.lastKnownError != null && state.lastKnownError.paper === false) {
                return true;
            }

            return false;
        },

        lowPaper(state) {
            if (state.lastKnownError != null && state.lastKnownError.lowPaper) {
                return true;
            }

            if (state.lastKnownStatus != null && state.lastKnownStatus.lowPaper) {
                return true;
            }

            return false;
        },

        headerFontClass(state) {
            if (state.isSpellingBee) {
                return 'cz2__font-sb';
            }

            return 'cz2__font-inter-black';
        },
    },

    mutations: {
        /**
         * Saves options.
         */
        SET_OPTIONS(state, options) {
            state.options = options;
        },

        /**
         * Self-destruct in ... 3... 2... 1...
         */
        SELFDESTUCT(state) {
            state.selfDestruct = true;
        },

        /**
         * Sets global busy status.
         */
        SET_GLOBAL_BUSY(state, v) {
            state.globalBusy = v;
        },

        /**
         * Sets online status.
         */
        SET_IS_ONLINE(state, v) {
            state.isOnline = v;
        },

        /**
         * Update current step.
         */
        SET_SELECTED_STEP(state, v) {
            if (v && v.step) {
                state.selectedStep = v.step;
                state.selectedStepParameters = v.parameters;
            } else {
                state.selectedStep = v;
                state.selectedStepParameters = null;
            }
        },

        /**
         * Saves window width.
         */
        SET_WINDOW_WIDTH(state, v) {
            state.windowWidth = v;
        },

        /**
         * Saves window height.
         */
        SET_WINDOW_HEIGHT(state, v) {
            state.windowHeight = v;
        },

        /**
         * Saves renderer height.
         */
        SET_RENDERER_HEIGHT(state, v) {
            state.rendererHeight = v;
        },

        /**
         * Save swipe lock state.
         */
        SET_LOCK_SWIPE(state, v) {
            state.lockSwipe = v;
        },

        SET_TIMEOUT_SHOWN(state, v) {
            state.timeoutShown = v;
        },

        SET_KIOSK_RESTART_SHOWN(state, v) {
            state.kioskRestartShown = v;
        },

        SET_SERVICE_MENU(state, v) {
            state.serviceMenuShown = v;
        },

        BUMP_UI(state) {
            state.uiInteractions += 1;
        },

        SET_PREFERRED_VIEW(state, v) {
            state.preferredView = v;
        },

        SET_FORCED_VIEW(state, v) {
            state.forcedView = v;
        },

        SET_SELECTED_TOGGLE_VIEW(state, v) {
            state.selectedToggleView = v;
        },

        SET_PRINTING_SHOWN(state, v) {
            state.printingShown = v;
        },

        SET_PRINTING_ERROR_SHOWN(state, v) {
            state.printingErrorShown = v;

            if (v) {
                state.lastKnownError = v;
            }
        },

        SET_SAVE_ERROR_SHOWN(state, v) {
            state.saveErrorShown = v;
        },

        SET_LAST_ERROR(state, v) {
            state.lastKnownError = v;
        },

        SET_LAST_STATUS(state, v) {
            state.lastKnownStatus = v;
        },

        SET_LOAD_STATE(state, v) {
            state.loadState = v;
        },

        SET_BACKGROUND_STATE(state, v) {
            state.backgroundState = v;
        },

        SET_CHANGE_WARNING_SHOWN(state, v) {
            state.changeWarningShown = v;
        },

        SET_OUT_OF_STOCK_WARNING_SHOWN(state, v) {
            state.outOfStockWarningShown = v;
        },

        SET_EXIT_MODAL_SHOWN(state, v) {
            state.exitModalShown = v;
        },

        SET_MOUSE_LEAVE_MODAL_SHOWN(state, v) {
            state.mouseLeaveModalShown = v;
        },

        SET_MOUSE_LEAVE_MODAL_WAS_SHOWN(state, v) {
            state.mouseLeaveModalWasShown = v;
        },

        SET_PROTECTOR_UPSELL_SHOWN(state, v) {
            state.protectorUpsellShown = v;
        },

        SET_DISCREET_PACKAGING_MODAL_SHOWN(state, v) {
            state.discreetPackagingModalShown = v;
        },

        SET_SPECIAL_BOX_MODAL_SHOWN(state, v) {
            state.specialBoxModalShown = v;
        },

        SET_SPECIAL_BOX_MODAL_WAS_SHOWN(state, v) {
            state.specialBoxModalWasShown = v;
        },

        SET_INSPECT_MODAL_SHOWN(state, v) {
            state.inspectModalShown = v;
        },

        SET_INSPECT_MODAL_COMPONENT(state, v) {
            state.inspectModalComponent = v;
        },

        SET_ATTACH_PACK_MODAL_SHOWN(state, v) {
            state.attachPackModalShown = v;
        },

        SET_ATTACH_PACK_MODAL_COMPONENT(state, v) {
            state.attachPackModalComponent = v;
        },

        SET_ATTACH_PACK_ADD_COMPONENT(state, v) {
            state.attachPackAddComponent = v;
        },

        SET_ATTACH_PACK_INFO_MODAL_SHOWN(state, v) {
            state.attachPackInfoModalShown = v;
        },

        SET_ATTACH_PACK_INFO_MODAL_WAS_SHOWN(state, v) {
            state.attachPackInfoModalWasShown = v;
        },

        SET_PET_PACK_INFO_MODAL_SHOWN(state, v) {
            state.petPackInfoModalShown = v;
        },

        SET_PRODUCT_INFO_MODAL_COMPONENT(state, v) {
            state.productInfoModalComponent = v;
        },

        SET_PRODUCT_INFO_MODAL_SHOWN(state, v) {
            state.productInfoModalShown = v;
        },

        SET_SWITCH_POP_MODAL_SHOWN(state, v) {
            state.switchPopModalShown = v;
        },

        SET_AI_MODAL_SHOWN(state, v) {
            state.aiModalShown = v;
        },

        SET_LAUNCHED_FROM_SWITCH_MODAL(state, v) {
            state.launchedFromSwitchModal = v;
        },

        SET_AI_SPINNER_SHOWN(state, v) {
            state.aiSpinnerShown = v;
        },

        SET_AI_BUILT_FROM_SELFIE(state, v) {
            state.builtFromSelfie = v;
        },

        SET_AI_PREVIEW_MODAL_SHOWN(state, v) {
            state.aiPreviewModalShown = v;
        },

        SET_NAME_POP_MODAL_SHOWN(state, v) {
            state.namePopModalShown = v;
        },

        SET_NAME_POP_MODAL_WAS_SHOWN(state, v) {
            state.namePopModalWasShown = v;
        },

        SET_NAME_POP_2_MODAL_WAS_SHOWN(state, v) {
            state.namePop2ModalWasShown = v;
        },

        SET_SKIN_TONE_MODAL_SHOWN(state, v) {
            state.skinToneModalShown = v;
        },

        SET_SHOW_CALENDAR_MODAL(state, v) {
            state.showCalendarModal = v;
        },

        SET_IS_SPELLING_BEE(state, v) {
            state.isSpellingBee = v;
        },

        SET_SHOW_SB_SELECTOR_MODAL(state, v) {
            state.showSbSelectorModal = v;
        },

        SET_IS_SB_AVAILABLE(state, v) {
            state.isSpellingBeeOptionAvailable = v;
        },

        SET_SB_TYPE(state, v) {
            state.spellingBeeType = v;
        },

        SET_HAS_SCROLLBAR(state, v) {
            state.hasScrollbar = v;
        },

        SET_AI_ACTIVE_STATE(state, v) {
            state.aiActiveState = v;
        },

        SET_AI_SELFIE_ACTIVE_STATE(state, v) {
            state.aiSelfieActiveState = v;
        },

        SET_AI_UPLOAD_ACTIVE_STATE(state, v) {
            state.aiUploadActiveState = v;
        },

        SET_PACK_TYPE(state, v) {
            state.packType = v;
        },

        SET_AI_TRIGGER(state, v) {
            state.deferAiTrigger = v;
        },

        SET_AI_FIRST_TIME(state, v) {
            state.aiFirstTime = v;
        },

        SET_SCREENSAVER_SHOWN(state, v) {
            state.screensaverShown = v;
        },

        SET_AUTO_ADD_HOLIDAY_CALENDAR(state, v) {
            state.autoAddHolidayCalendar = v;
        },
    },

    actions: {
        /**
         * Saves options.
         */
        setOptions({ commit }, options) {
            commit('SET_OPTIONS', options);
        },

        /**
         * Select a new step.
         */
        selectStep({ state, commit }, v) {
            if (v == null && state.selectedStepParameters && state.selectedStepParameters.returnTo) {
                commit('SET_SELECTED_STEP', state.selectedStepParameters.returnTo);
            } else {
                commit('SET_SELECTED_STEP', v);
            }
        },

        /**
         * Cancels out from the widget.
         */
        globalCancel({ commit, state }) {
            if (state.options && state.options.onCancel) {
                state.options.onCancel();
            }

            commit('SELFDESTUCT');
        },

        /**
         * Cancels out from the widget.
         */
        globalSaveCancel({ commit, state }, result) {
            if (state.options && state.options.onSaveCancel) {
                state.options.onSaveCancel(result);
            }

            commit('SELFDESTUCT');
        },

        /**
         * Sends out a notification that the widget is busy.
         */
        globalBusy({ commit, state }, busy) {
            commit('SET_GLOBAL_BUSY', busy);

            if (state.options && state.options.onBusy) {
                state.options.onBusy(busy);
            }
        },

        /**
         * Sends out successful message and closes the widget.
         */
        globalDone({ state }, result) {
            if (state.options && state.options.onDone) {
                state.options.onDone(result);
            }

            // Don't self destruct, that will be the responsibility of the Funko host.
            // commit('SELFDESTUCT');
        },

        /**
         * Set if the app is online
         */
        setIsOnline({ commit }, v) {
            commit('SET_IS_ONLINE', v);
        },

        /**
         * Send analytics event.
         */
        analytics({ state }, event) {
            if (state.options.onAnalytics) {
                state.options.onAnalytics(event);
            }
        },

        /**
         * Saves window width.
         */
        setWindowWidth({ commit }, v) {
            commit('SET_WINDOW_WIDTH', v);
        },

        /**
         * Saves window height.
         */
        setWindowHeight({ commit }, v) {
            commit('SET_WINDOW_HEIGHT', v);
        },

        /**
         * Saves renderer height.
         */
        setRendererHeight({ commit }, v) {
            commit('SET_RENDERER_HEIGHT', v);
        },

        /**
         * Sets height.
         */
        setHeight({ state }, v) {
            if (state.options.onSetHeight) {
                state.options.onSetHeight(v);
            }
        },

        /**
         * Dispatch event on a global event bus.
         */
        globalEvent({ state }, { event, data }) {
            state.eventBus.$emit(event, data);
        },

        /**
         * Sends a message to external log.
         */
        log({ state }, {
            level,
            message,
            style,
        }) {
            if (lastLogMessage !== message) {
                lastLogMessage = message;

                if (state.options && state.options.onLog) {
                    state.options.onLog(level, message);
                }

                if (style) {
                    // eslint-disable-next-line
                    console.log(`%c${level}: ${message}`, style);
                } else {
                    // eslint-disable-next-line
                    console.log(`${level}: ${message}`);
                }
            }
        },

        /**
         * Show timeout popup.
         */
        showTimeoutWarning({ commit }, v) {
            commit('SET_TIMEOUT_SHOWN', v);
        },

        showKioskRestartWarning({ commit }, v) {
            commit('SET_KIOSK_RESTART_SHOWN', v);
        },

        showServiceMenu({ commit }, v) {
            commit('SET_SERVICE_MENU', v);
        },

        /**
         * Service menu enabler.
         */
        tapLogo({ state, dispatch }) {
            const now = new Date().getTime();

            let delay = 1000;
            let taps = 5;

            if (state.options.configuration) {
                delay = state.options.configuration.serviceMenuDelay || 1000;
                taps = state.options.configuration.serviceMenuTaps || 5;
            }

            if (lastLogoTap == null || now - lastLogoTap < delay) {
                if (lastLogoTap == null) {
                    lastLogoTap = now;
                }

                logoTaps += 1;

                dispatch('log', {
                    level: 'info',
                    message: `Service menu tap after ${now - lastLogoTap}ms (max ${delay} delay), now count ${logoTaps} out of ${taps}`,
                });

                lastLogoTap = now;

                if (logoTaps > taps) {
                    dispatch('log', {
                        level: 'info',
                        message: 'Show service menu',
                    });

                    logoTaps = 0;

                    dispatch('showServiceMenu', true);
                }
            } else {
                dispatch('log', {
                    level: 'info',
                    message: 'Service menu taps too slow',
                });

                lastLogoTap = null;
                logoTaps = 0;
            }
        },

        /**
         * Track UI interactions.
         */
        uiInteracted({ commit }) {
            commit('BUMP_UI');
        },

        /**
         * Prefer a view in the renderer.
         */
        setPreferredView({ commit }, v) {
            commit('SET_PREFERRED_VIEW', v);
        },

        /**
         * If a renderer is hidden, show it and select a view.
         */
        setForcedView({ commit }, v) {
            commit('SET_FORCED_VIEW', v);
        },

        /**
         * Prefer a view in the renderer.
         */
        setSelectedToggleView({ commit }, v) {
            commit('SET_SELECTED_TOGGLE_VIEW', v);
        },

        showPrintingProgress({ commit }, v) {
            commit('SET_PRINTING_SHOWN', v);
        },

        showPrintingError({ commit }, v) {
            commit('SET_PRINTING_ERROR_SHOWN', v);
        },

        showSaveError({ commit }, v) {
            commit('SET_SAVE_ERROR_SHOWN', v);
        },

        setLastError({ commit }, v) {
            commit('SET_LAST_ERROR', v);
        },

        loadState({ commit }, v) {
            commit('SET_LOAD_STATE', v);
        },

        setBackgroundState({ commit }, v) {
            commit('SET_BACKGROUND_STATE', v);
        },

        showChangeWarning({ commit }, v) {
            commit('SET_CHANGE_WARNING_SHOWN', v);
        },

        showOutOfStockWarning({ commit }, v) {
            commit('SET_OUT_OF_STOCK_WARNING_SHOWN', v);
        },

        showExitModal({ commit }, v) {
            commit('SET_EXIT_MODAL_SHOWN', v);
        },

        showMouseLeaveModal({ commit }, v) {
            commit('SET_MOUSE_LEAVE_MODAL_SHOWN', v);
        },

        setMouseLeaveModalWasShown({ commit }, v) {
            commit('SET_MOUSE_LEAVE_MODAL_WAS_SHOWN', v);
        },

        showProtectorUpsell({ commit }, v) {
            commit('SET_PROTECTOR_UPSELL_SHOWN', v);
        },

        showDiscreetPackagingModal({ commit }, v) {
            commit('SET_DISCREET_PACKAGING_MODAL_SHOWN', v);
        },

        showSpecialBoxModal({ commit }, v) {
            commit('SET_SPECIAL_BOX_MODAL_SHOWN', v);
        },

        setSpecialBoxModalWasShown({ commit }, v) {
            commit('SET_SPECIAL_BOX_MODAL_WAS_SHOWN', v);
        },

        showInspectModal({ commit }, v) {
            commit('SET_INSPECT_MODAL_SHOWN', v);
        },

        setInspectModalComponent({ commit }, v) {
            commit('SET_INSPECT_MODAL_COMPONENT', v);
        },

        showAttachPackModal({ commit }, v) {
            commit('SET_ATTACH_PACK_MODAL_SHOWN', v);
        },

        setAttachPackModalComponent({ commit }, v) {
            commit('SET_ATTACH_PACK_MODAL_COMPONENT', v);
        },

        setAttachPackAddComponent({ commit }, v) {
            commit('SET_ATTACH_PACK_ADD_COMPONENT', v);
        },

        showAttachPackInfoModal({ commit }, v) {
            commit('SET_ATTACH_PACK_INFO_MODAL_SHOWN', v);
        },

        setAttachPackInfoModalWasShown({ commit }, v) {
            commit('SET_ATTACH_PACK_INFO_MODAL_WAS_SHOWN', v);
        },

        showPetPackInfoModal({ commit }, v) {
            commit('SET_PET_PACK_INFO_MODAL_SHOWN', v);
        },

        setProductInfoModalComponent({ commit }, v) {
            commit('SET_PRODUCT_INFO_MODAL_COMPONENT', v);
        },

        showProductInfoModal({ commit }, v) {
            commit('SET_PRODUCT_INFO_MODAL_SHOWN', v);
        },

        showSwitchPopModal({ commit }, v) {
            commit('SET_SWITCH_POP_MODAL_SHOWN', v);
        },

        setLaunchedFromSwitchModal({ commit }, v) {
            commit('SET_LAUNCHED_FROM_SWITCH_MODAL', v);
        },

        showAiModal({ commit }, v) {
            commit('SET_AI_MODAL_SHOWN', v);
        },

        showAiSpinner({ commit }, v) {
            commit('SET_AI_SPINNER_SHOWN', v);
        },

        setBuiltFromSelfie({ commit }, v) {
            commit('SET_AI_BUILT_FROM_SELFIE', v);
        },

        showAiPreviewModal({ commit }, v) {
            commit('SET_AI_PREVIEW_MODAL_SHOWN', v);
        },

        showNamePopModal({ commit }, v) {
            commit('SET_NAME_POP_MODAL_SHOWN', v);
        },

        setNamePopModalWasShown({ commit }, v) {
            commit('SET_NAME_POP_MODAL_WAS_SHOWN', v);
        },

        setNamePop2ModalWasShown({ commit }, v) {
            commit('SET_NAME_POP_2_MODAL_WAS_SHOWN', v);
        },

        setShowCalendarModal({ commit }, v) {
            commit('SET_SHOW_CALENDAR_MODAL', v);
        },

        showSkinToneModal({ commit }, v) {
            commit('SET_SKIN_TONE_MODAL_SHOWN', v);
        },

        scrollToApp() {
            let appElement = document.querySelector('#cz2');

            if (appElement) {
                let appTopPosition = 0;

                while (appElement) {
                    appTopPosition += appElement.offsetTop;

                    appElement = appElement.offsetParent;
                }

                window.scrollTo({
                    left: 0,
                    top: appTopPosition,
                    behavior: 'instant',
                });
            }
        },

        checkPrinterStatus({ state, dispatch }) {
            if (state.options && state.options.onCheckPrinter) {
                state.options.onCheckPrinter().then((status) => {
                    dispatch('setLastError', null);
                    dispatch('setLastStatus', status);
                }).catch((error) => {
                    dispatch('setLastError', error);

                    // Go to splash.
                    // UPDATE: Do not navigate back to splash if we ran out of paper, let the user continue.
                    // if (error && error.paper === false) {
                    //     if (this.currentGroupCode !== 'Checkout' && this.currentGroupCode !== 'Confirm') {
                    //         this.$store.dispatch('resetCustomizations');
                    //         this.$store.dispatch('selectStep', 'splash');
                    //     }
                    // }
                });
            }
        },

        setLastStatus({ commit }, v) {
            commit('SET_LAST_STATUS', v);
        },

        setIsSpellingBeeAvailable({ commit }, v) {
            commit('SET_IS_SB_AVAILABLE', v);
        },

        setIsSpellingBee({ commit }, v) {
            commit('SET_IS_SPELLING_BEE', v);
        },

        setShowSbSelectorModal({ commit }, v) {
            commit('SET_SHOW_SB_SELECTOR_MODAL', v);
        },

        setSpellingBeeType({ commit }, v) {
            commit('SET_SB_TYPE', v);
        },

        setHasScrollbar({ commit }, v) {
            commit('SET_HAS_SCROLLBAR', v);
        },

        setAiActiveState({ state, commit }, v) {
            if (!Object.prototype.hasOwnProperty.call(state.aiStates, v)) {
                throw new Error(`Invalid ai state provided: ${v}`);
            }

            commit('SET_AI_ACTIVE_STATE', v);
        },

        setAiSelfieActiveState({ state, commit }, v) {
            if (!Object.prototype.hasOwnProperty.call(state.aiSelfieStates, v)) {
                throw new Error(`Invalid ai selfie state provided: ${v}`);
            }

            commit('SET_AI_SELFIE_ACTIVE_STATE', v);
        },

        setAiUploadActiveState({ state, commit }, v) {
            if (!Object.prototype.hasOwnProperty.call(state.aiUploadStates, v)) {
                throw new Error(`Invalid ai photo upload state provided: ${v}`);
            }

            commit('SET_AI_UPLOAD_ACTIVE_STATE', v);
        },

        setPackType({ commit }, v) {
            commit('SET_PACK_TYPE', v);
        },

        setAiTrigger({ commit }, v) {
            commit('SET_AI_TRIGGER', v);
        },

        setAiFirstTime({ commit }, v) {
            commit('SET_AI_FIRST_TIME', v);
        },

        setScreensaverShown({ commit }, v) {
            commit('SET_SCREENSAVER_SHOWN', v);
        },

        /**
         * Resets AI modal states.
         */
        resetAiStates({ state, dispatch }) {
            if (state.aiSelfieActiveState !== state.aiSelfieStates.default) {
                dispatch('setAiSelfieActiveState', state.aiSelfieStates.default);
            }

            if (state.aiUploadActiveState !== state.aiUploadStates.loading) {
                dispatch('setAiUploadActiveState', state.aiUploadStates.loading);
            }
        },

        setAutoAddHolidayCalendar({ commit }, v) {
            commit('SET_AUTO_ADD_HOLIDAY_CALENDAR', v);
        },
    },

    modules: {
        ecommerce: ecommerceStore,
        customizer: customizerStore,
    },
};
